// removed by extract-text-webpack-plugin
module.exports = {"clearBtn":"_1LWdPmaLSf0ueW19JjElan"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMClearButton/OMClearButton.scss
// module id = 1657
// module chunks = 0